import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import {CommonModule} from '@angular/common';
// @ts-ignore
import {
    AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    signal,
    ViewChild
} from '@angular/core';
// @ts-ignore
import {FormsModule} from '@angular/forms';
// @ts-ignore
import {LucideAngularModule, ZoomIn, ZoomOut} from 'lucide-angular';
// @ts-ignore
import {firstValueFrom} from 'rxjs';
import {SankhyaGatewayService} from '../../services/sankhya-gateway.service';
import {ProdutoService} from '../../services/produto.service';
import {UsuarioLogadoService} from '../../services/usuario-logado.service';
import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';
import {paginarVenda} from './paginar-venda';
import {CodigoBarrasNunota, gerarCodigoBarrasNunota} from './codigo-barras-nunota';


// @ts-ignore
@Component({
    selector: 'app-gpl-venda-impressao',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule, LucideAngularModule],
    templateUrl: './gpl-venda-impressao.component.html',
    styleUrl: './gpl-venda-impressao.component.css'
})
export class GplVendaImpressaoComponent implements OnInit, AfterViewChecked, OnDestroy {
    ordenacaoProdutos = '';
    produtosOrdemAsc = true;

    @ViewChild('modalItensZerados')
    private modalItensZerados?: ElementRef<HTMLDialogElement>;
    acaoPendenteItensZerados: 'imprimir' | 'pdf' | null = null;

    ordenarProdutos(campo: string): void {
        if (!['ord', 'partnumber', 'descricao', 'unitarioDolar', 'unitarioReal', 'total'].includes(campo)) return;
        this.produtosOrdemAsc = this.ordenacaoProdutos === campo ? !this.produtosOrdemAsc : true;
        this.ordenacaoProdutos = campo;
    }

    ordemProdutosAria(campo: string): string {
        return this.ordenacaoProdutos === campo ? (this.produtosOrdemAsc ? 'ascending' : 'descending') : 'none';
    }

    itensOrdenados(documento: {items: any[]; data: any}): any[] {
        if (!this.ordenacaoProdutos) return documento.items;
        const chave = (item: any): string | number => {
            switch (this.ordenacaoProdutos) {
                case 'ord': return this.numeroMonetario(item?.SEQUENCIA);
                case 'partnumber': return this.value(item, 'REFFORN');
                case 'descricao': return this.value(item, 'DESCRPROD');
                case 'unitarioDolar': return this.arredondarValor(this.valorUnitarioDolarVisual(item, documento.data));
                case 'unitarioReal': return this.arredondarValor(this.valorUnitarioVisual(item, documento.data));
                default: return this.totalItemExibicao(item, documento.data);
            }
        };
        // Ordena so a apresentacao, preservando a ordem original usada no rateio dos descontos.
        return documento.items.map((item, indice) => ({item, indice, valor: chave(item)}))
            .sort((a, b) => {
                const comparacao = typeof a.valor === 'number' && typeof b.valor === 'number'
                    ? a.valor - b.valor
                    : String(a.valor).localeCompare(String(b.valor), 'pt-BR', {numeric: true, sensitivity: 'base'});
                return (this.produtosOrdemAsc ? comparacao : -comparacao) || a.indice - b.indice;
            }).map(linha => linha.item);
    }

    // Os cabecalhos visiveis sao clones da paginacao; recebem eventos pelo host.
    @HostListener('click', ['$event'])
    @HostListener('keydown', ['$event'])
    ordenarProdutosPeloCabecalho(event: MouseEvent | KeyboardEvent): void {
        if (event.type === 'keydown' && !['Enter', ' '].includes((event as KeyboardEvent).key)) return;
        const alvo = event.target as HTMLElement | null;
        const cabecalho = alvo?.closest<HTMLElement>('th[data-ordenar-produtos]');
        if (!cabecalho || !this.elementRef.nativeElement.contains(cabecalho)) return;
        event.preventDefault();
        this.ordenarProdutos(cabecalho.dataset['ordenarProdutos'] || '');
    }
    private readonly codigosBarras = new Map<string, CodigoBarrasNunota | null>();
    private documentosPaginados: unknown;
    private opcoesPaginadas = '';
    private paginacaoTimer?: ReturnType<typeof setTimeout>;
    private destruido = false;
    private preparandoPaginas?: Promise<void>;
    readonly erroPaginacao = signal('');
    @Input() modoModal = false;
    @Output() activeViewChange = new EventEmitter<'demonstrativo-vendas'>();
    @Output() fecharModal = new EventEmitter<void>();

    readonly ZoomIn = ZoomIn;
    readonly ZoomOut = ZoomOut;

    carregando = signal(false);

    vendaZoomAtual = 1.0;
    parametros = false;
    impressaoPB = true;
    autoPrintAtivo = false;
    printEmAndamento = false;
    possuiCoreAtual = false;
    aguardandoSelecaoVenda = false;
    mostrarIrTopo = false;
    mostrarIrFinal = false;
    buscaClienteTexto = '';
    buscaDataInicial = this.formatarDataInput(this.diasAntes(new Date(), 7));
    buscaDataFinal = this.formatarDataInput(new Date());
    clientesBusca: any[] = [];
    notasCliente: any[] = [];
    notasNavegacao: any[] = [];
    indiceNotaNavegacao = -1;
    clienteSelecionadoBusca: any = null;
    dropdownClientesAberto = false;
    buscaMensagem = 'Digite o CNPJ ou nome do cliente para localizar as ultimas notas.';
    private buscaClienteTimer: ReturnType<typeof setTimeout> | null = null;
    private readonly estadoRetornoDemonstrativoKey = 'param_demonstrativo_vendas_estado_retorno';
    private readonly navegacaoVendaImpressaoKey = 'param_venda_impressao_navegacao';
    private readonly conditionKeyPorProduto = new Map<string, Promise<string>>();
    private origemVoltarImpressao: 'demonstrativo' | 'busca' | null = null;

    params: any = {
        IMP_DESC: true,
        IMP_FABR: false,
        IMP_CD: false,
        IMP_VLR: true,
        IMP_DOL: true,
        IMP_TOT: true,
        IMP_PN: true,
        IMP_FAT: true,
        IMP_ENT: true,
        IMP_IPI: true,
        IMP_ST: true,
        IMP_DES: false,
        IMP_MOEDA: 'BRL'
    };

    data: any = {};
    items: any[] = [];
    contas: any[] = [];
    documentos: Array<{
        data: any;
        items: any[];
        contas: any[];
        possuiCoreAtual: boolean;
        printDate: string;
    }> = [];

    printDate = '';

    constructor(
        private readonly sankhyaGateway: SankhyaGatewayService,
        private readonly produtoService: ProdutoService,
        private readonly usuarioLogadoService: UsuarioLogadoService,
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly zone: NgZone
    ) {
    }

    ngOnInit(): void {
        this.restaurarNavegacaoDemonstrativo();
        this.render();
    }

    ngAfterViewChecked(): void {
        const opcoes = JSON.stringify([this.params, this.impressaoPB, this.aguardandoSelecaoVenda, this.ordenacaoProdutos, this.produtosOrdemAsc]);
        if (this.documentosPaginados === this.documentos && this.opcoesPaginadas === opcoes) return;
        this.documentosPaginados = this.documentos;
        this.opcoesPaginadas = opcoes;
        clearTimeout(this.paginacaoTimer);
        this.zone.runOutsideAngular(() => {
            this.paginacaoTimer = setTimeout(() => void this.prepararPaginas().catch(erro => {
                console.error('Erro ao paginar venda:', erro);
            }), 0);
        });
    }

    ngOnDestroy(): void {
        this.destruido = true;
        clearTimeout(this.paginacaoTimer);
    }

    private async prepararPaginas(): Promise<void> {
        if (this.preparandoPaginas) await this.preparandoPaginas;
        if (this.destruido) return;
        const preparar = async () => {
            const raiz = this.elementRef.nativeElement;
            const origem = raiz.querySelector<HTMLElement>('.source-pages');
            const destino = raiz.querySelector<HTMLElement>('.paginated-pages');
            if (!origem || !destino) return;
            await document.fonts.ready;
            await Promise.all(Array.from(origem.querySelectorAll('img')).map(img =>
                img.decode().catch(() => undefined)));
            if (this.destruido || !origem.isConnected) return;
            destino.replaceChildren();
            const zoom = destino.style.getPropertyValue('zoom');
            destino.style.setProperty('zoom', '1');
            try {
                paginarVenda(origem, destino);
                this.erroPaginacao.set('');
                raiz.classList.add('pagination-ready');
            } catch (erro) {
                destino.replaceChildren();
                raiz.classList.remove('pagination-ready');
                this.erroPaginacao.set(erro instanceof Error ? erro.message : 'Nao foi possivel paginar a venda.');
                throw erro;
            } finally {
                destino.style.setProperty('zoom', zoom);
            }
        };
        this.preparandoPaginas = preparar();
        try { await this.preparandoPaginas; } finally { this.preparandoPaginas = undefined; }
    }

    @HostListener('window:beforeprint')
    prepararImpressaoNavegador(): void {
        const raiz = this.elementRef.nativeElement;
        const origem = raiz.querySelector<HTMLElement>('.source-pages');
        const destino = raiz.querySelector<HTMLElement>('.paginated-pages');
        if (origem && destino) {
            if (destino.childElementCount) return;
            destino.replaceChildren();
            paginarVenda(origem, destino);
            raiz.classList.add('pagination-ready');
        }
    }

    async render(): Promise<void> {
        this.carregando.set(true);

        try {
            const loteAutomatico = this.consumirLoteAutomatico();

            if (loteAutomatico.length > 1) {
                const documentos = await this.carregarDocumentosImpressao(loteAutomatico);

                if (!documentos.length) {
                    this.limparDocumentoAtual();
                    this.aguardandoSelecaoVenda = true;
                    this.aplicarModoImpressao();
                    return;
                }

                this.documentos = documentos;
                this.aplicarDocumentoAtual(documentos[0]);
                this.aguardandoSelecaoVenda = false;
                this.aplicarModoImpressao();
                this.agendarPrintAutomatico();
                return;
            }

            const data = await this.fetchOrcamentoData();

            if (!data) {
                this.limparDocumentoAtual();
                this.aguardandoSelecaoVenda = true;
                this.aplicarModoImpressao();
                return;
            }

            const dataImpressao = new Date();
            data.HRATUAL = dataImpressao.toLocaleTimeString('pt-BR');

            const documento = {
                data,
                items: data.items || [],
                contas: await this.carregarContasPix(data),
                possuiCoreAtual: (data.items || []).some((item: any) => this.itemPossuiCore(item)),
                printDate: dataImpressao.toLocaleString('pt-BR')
            };

            this.documentos = [documento];
            this.aplicarDocumentoAtual(documento);
            this.aguardandoSelecaoVenda = false;

            this.aplicarModoImpressao();
            this.agendarPrintAutomatico();

            this.parametros = true;

        } catch (e) {
            console.error('Erro ao renderizar impressão:', e);
        } finally {
            this.carregando.set(false);
            setTimeout(() => this.atualizarNavegacaoRolagem());
        }
    }

    async fetchOrcamentoData(nunotaInformada?: string): Promise<any> {
        const paramsUrl = new URLSearchParams(location.search);
        let nunota: string | null = nunotaInformada || paramsUrl.get('NUNOTA') || paramsUrl.get('nunota');

        const storage = this.getSessionStorage();
        if (
            storage?.getItem(this.estadoRetornoDemonstrativoKey) ||
            storage?.getItem('param_venda_impressao_retorno') === 'demonstrativo-vendas'
        ) {
            this.origemVoltarImpressao = 'demonstrativo';
        }

        if (!nunota && storage) {
            nunota = storage.getItem('param_venda_impressao_nunota');
            storage.removeItem('param_venda_impressao_nunota');
        }

        if (!nunota) {
            nunota = this.consumirNunotaDaFila(storage);
        }

        this.autoPrintAtivo = !!(
            storage &&
            storage.getItem('param_venda_impressao_auto_print') === 'S' &&
            nunota
        );

        if (!nunota) {
            return null;
        }

        try {
            const response: any = await this.respostaGateway(
                this.sankhyaGateway.consultarOrcamentoImpressao({
                    NUNOTA: Number(nunota)
                })
            );

            if (response?.sucesso && response?.orcamento) {
                const orcamento = response.orcamento;
                this.normalizarItensImpressao(orcamento);
                await Promise.all([
                    this.enriquecerConditionKeyItens(orcamento, nunota),
                    this.enriquecerDadosUsuarioLogado(orcamento)
                ]);
                return orcamento;
            }

            console.warn('Resposta inesperada ao consultar orçamento:', response);

        } catch (e) {
            console.error('Erro ao consultar orçamento:', e);
        }

        return null;
    }


    private normalizarItensImpressao(orcamento: any): void {
        const itens = Array.isArray(orcamento?.items) ? orcamento.items : [];

        for (const item of itens) {
            const valorUnitario = this.numeroMonetario(item?.VLRUNIT);

            // Tanto o zero real quanto o valor simbólico
            // devem receber o sombreamento.
            item.valorSimbolicoZerado =
                valorUnitario === 0 || valorUnitario === 0.01;

            // Somente o preço simbólico de 0,01 precisa
            // ter seus valores normalizados para zero.
            if (valorUnitario !== 0.01) continue;

            item.VLRUNIT = 0;
            item.VLRTOT = 0;
            item.VLRUNITMOEDA = 0;
            item.VLRDESC = 0;
            item.PERCDESC = 0;
        }
    }


    ultimaPalavraDeposito(account: any): string {
        const descricao = String(account?.deposito || account?.DEPOSITO || '').trim();
        return descricao.split(/\s+/).pop() || '';
    }

    iconeBanco(account: any): string | null {
        const descricao = String(account?.deposito || account?.DEPOSITO || '').toUpperCase();
        const banco = ['bradesco', 'sicoob', 'santander']
            .find(nome => new RegExp(`\\b${nome}\\b`, 'i').test(descricao));
        return banco ? `assets/bancos/${banco}.svg` : null;
    }

    conditionKeyItem(item: any): string {
        return String(
            item?.AD_CONDICAO ??
            item?.adCondicao ??
            item?.ad_condicao ??
            item?.CONDITION_KEY ??
            item?.conditionKey ??
            item?.CD ??
            item?.CONDICAO ??
            ''
        ).trim().toUpperCase();
    }

    conteudoFabricanteCdItem(item: any): string {
        const partes: string[] = [];
        const fabricante = this.value(item, 'DESCRMAR') || this.value(item, 'FABRICANTE');
        const conditionKey = this.conditionKeyItem(item);

        if (this.visivel('IMP_FABR') && fabricante) {
            partes.push(fabricante);
        }
        if (this.visivel('IMP_CD') && conditionKey) {
            partes.push(`CD: ${conditionKey}`);
        }

        return partes.join(' - ');
    }

    private async enriquecerConditionKeyItens(orcamento: any, nunota: string): Promise<any> {
        const itens = Array.isArray(orcamento?.items) ? orcamento.items : [];

        try {
            const resposta = await firstValueFrom(
                this.produtoService.buscarCondicoesVenda(Number(nunota))
            );
            if (!resposta?.sucesso) {
                throw new Error(resposta?.erro || 'A consulta nativa nao retornou os CDs da venda.');
            }

            const condicoes = Array.isArray(resposta?.itens) ? resposta.itens : [];
            const porSequencia = new Map<string, (typeof condicoes)[number]>();
            condicoes.forEach(item => {
                porSequencia.set(this.chaveSequencia(item.SEQUENCIA), item);
            });

            itens.forEach((item: any) => {
                const dadosProduto = porSequencia.get(this.chaveSequencia(item?.SEQUENCIA));
                if (!dadosProduto) return;

                if (!String(item?.CODPROD ?? '').trim()) {
                    item.CODPROD = dadosProduto.CODPROD;
                }
                if (!this.conditionKeyItem(item) && dadosProduto.AD_CONDICAO) {
                    item.AD_CONDICAO = dadosProduto.AD_CONDICAO;
                }
            });
        } catch (erro) {
            console.warn(`[VendaImpressao] Nao foi possivel buscar os CDs da venda ${nunota}.`, erro);
        }

        await Promise.all(itens.map(async (item: any) => {
            if (this.conditionKeyItem(item)) return;

            const codprod = String(
                item?.CODPROD ?? item?.codprod ?? item?.codProd ?? ''
            ).trim();

            if (!/^\d+$/.test(codprod)) return;

            const conditionKey = await this.buscarConditionKeyProduto(codprod);
            if (conditionKey) item.AD_CONDICAO = conditionKey;
        }));

        return orcamento;
    }

    private chaveSequencia(valor: unknown): string {
        const numero = Number(String(valor ?? '').replace(',', '.'));
        return Number.isFinite(numero) ? String(numero) : String(valor ?? '').trim();
    }

    private buscarConditionKeyProduto(codprod: string): Promise<string> {
        const existente = this.conditionKeyPorProduto.get(codprod);
        if (existente) return existente;

        const consulta = firstValueFrom(
            this.produtoService.buscarProdutoCompleto(Number(codprod))
        )
            .then((resposta) => String(resposta?.dados?.['AD_CONDICAO'] ?? '').trim().toUpperCase())
            .catch((erro) => {
                console.warn(`[VendaImpressao] Nao foi possivel buscar o CD do produto ${codprod}.`, erro);
                return '';
            });

        this.conditionKeyPorProduto.set(codprod, consulta);
        return consulta;
    }

    private async enriquecerDadosUsuarioLogado(orcamento: any): Promise<void> {
        try {
            const resposta = await firstValueFrom(
                this.usuarioLogadoService.buscarDados()
            );

            if (!resposta?.sucesso) {
                throw new Error(resposta?.erro || 'A consulta nativa nao retornou os dados do usuario logado.');
            }

            orcamento.USUARIO_LOGADO = resposta.dados || {};
            orcamento.CODUSULOGADO = resposta.codusu;
            orcamento.NOMEUSULOGADO = resposta.nomeUsuario || '';
            orcamento.NOMECOMPLETOUSULOGADO = resposta.nomeCompleto || '';
            orcamento.EMAILUSULOGADO = resposta.email || '';
        } catch (erro) {
            console.warn('[VendaImpressao] Nao foi possivel carregar os dados do usuario logado.', erro);
            orcamento.USUARIO_LOGADO = {};
            orcamento.EMAILUSULOGADO = '';
        }
    }

    async carregarDocumentosImpressao(nunotas: string[]): Promise<Array<{
        data: any;
        items: any[];
        contas: any[];
        possuiCoreAtual: boolean;
        printDate: string;
    }>> {
        const documentos = [];

        for (const nunota of nunotas) {
            const data = await this.fetchOrcamentoData(nunota);

            if (!data) {
                continue;
            }

            const dataImpressao = new Date();
            data.HRATUAL = dataImpressao.toLocaleTimeString('pt-BR');
            const items = data.items || [];

            documentos.push({
                data,
                items,
                contas: await this.carregarContasPix(data),
                possuiCoreAtual: items.some((item: any) => this.itemPossuiCore(item)),
                printDate: dataImpressao.toLocaleString('pt-BR')
            });
        }

        return documentos;
    }

    async carregarContasPix(data: any): Promise<any[]> {
        try {
            // VLRNOTA ja inclui descontos e impostos: e a mesma origem do Total Geral.
            // Pix permanece em reais, independentemente da moeda escolhida na impressao.
            const valorPix = this.numeroMonetario(data?.VLRNOTA);

            const response: any = await this.respostaGateway(
                this.sankhyaGateway.gerarQrCodeImpressao({
                    valor: valorPix.toFixed(2)
                })
            );

            if (response?.sucesso && response?.contas) {
                return response.contas;
            }

        } catch (e) {
            console.warn(
                'Não foi possível gerar QR Code PIX. Usando dados do orçamento.',
                e
            );
        }

        return data.contas || [];
    }

    agendarBuscaClientes(): void {
        if (this.buscaClienteTimer) {
            clearTimeout(this.buscaClienteTimer);
        }

        this.buscaClienteTimer = setTimeout(() => this.buscarClientes(), 250);
    }

    async buscarClientes(): Promise<void> {
        const filtro = this.buscaClienteTexto.trim();
        this.clienteSelecionadoBusca = null;
        this.notasCliente = [];
        this.limparNavegacaoVendas();

        if (filtro.length < 2) {
            this.clientesBusca = [];
            this.dropdownClientesAberto = false;
            this.buscaMensagem = 'Digite ao menos 2 caracteres para buscar o cliente.';
            return;
        }

        this.buscaMensagem = 'Buscando clientes...';
        this.dropdownClientesAberto = true;

        try {
            const response: any = await this.respostaObservable(
                this.sankhyaGateway.buscarClientesNativo(filtro)
            );

            if (!response) {
                this.clientesBusca = [];
                this.buscaMensagem = 'Resposta vazia do gateway. Tente novamente.';
                return;
            }

            if (response.status && response.status !== '1') {
                this.clientesBusca = [];
                this.buscaMensagem = response.statusMessage ||
                    'A pesquisa nativa de clientes não retornou sucesso.';
                return;
            }

            const dadosNativos = this.extrairDadosPesquisaNativaCliente(response);
            const lista = this.normalizarClientesBuscaNativa(dadosNativos);
            this.clientesBusca = this.removerClientesDuplicados(lista);
            this.buscaMensagem = this.clientesBusca.length ? '' : 'Nenhum cliente encontrado.';
        } catch (e) {
            console.error('Erro ao buscar clientes para impressao:', e);
            this.clientesBusca = [];
            this.buscaMensagem = 'Erro ao buscar clientes.';
        }
    }

    private respostaObservable<T = any>(observable: any): Promise<T> {
        return firstValueFrom(observable) as Promise<T>;
    }

    private extrairDadosPesquisaNativaCliente(
        value: any
    ): Array<Record<string, unknown>> {
        const body = value?.responseBody || value;

        const jsonBruto =
            body?.json?.['$'] ??
            body?.json?.$ ??
            body?.json ??
            '';

        if (!jsonBruto) {
            return [];
        }

        try {
            const resultado =
                typeof jsonBruto === 'string'
                    ? JSON.parse(jsonBruto)
                    : jsonBruto;

            return Array.isArray(resultado?.data)
                ? resultado.data
                : [];
        } catch (error) {
            console.error(
                'Erro ao interpretar retorno do PesquisaSP.getSuggestion:',
                error,
                jsonBruto
            );

            return [];
        }
    }

    private normalizarClientesBuscaNativa(lista: unknown): any[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        const grupos = new Map<string, any>();

        for (const item of lista) {
            const cliente = item as Record<string, unknown>;

            const codparc =
                this.valorBusca(cliente, 'CODPARC') ||
                this.valorBusca(cliente, 'codparc');

            const nomeparc =
                this.valorBusca(cliente, 'NOMEPARC') ||
                this.valorBusca(cliente, 'RAZAOSOCIAL') ||
                this.valorBusca(cliente, 'nomeparc') ||
                this.valorBusca(cliente, 'nomeParc');

            const docparc =
                this.valorBusca(cliente, 'CGC_CPF') ||
                this.valorBusca(cliente, 'CGC') ||
                this.valorBusca(cliente, 'CNPJ') ||
                this.valorBusca(cliente, 'DOCPARC') ||
                this.valorBusca(cliente, 'docparc');

            if (!codparc || !nomeparc) {
                continue;
            }

            const documento = String(docparc || '').replace(/\D/g, '');
            const chave = documento || `CODPARC:${codparc}`;
            const existente = grupos.get(chave);

            if (existente) {
                const codigos = existente.codparcs || [];
                const jaExiste = codigos.some(
                    (codigo: string) => String(codigo) === String(codparc)
                );

                if (!jaExiste) {
                    codigos.push(codparc);
                }

                existente.codparcs = codigos;
                continue;
            }

            grupos.set(chave, {
                codparc,
                codparcs: [codparc],
                nomeparc,
                docparc
            });
        }

        return Array.from(grupos.values());
    }

    async selecionarClienteBusca(cliente: any): Promise<void> {
        this.clienteSelecionadoBusca = cliente;
        this.buscaClienteTexto = this.labelClienteBusca(cliente);
        this.clientesBusca = [];
        this.dropdownClientesAberto = false;
        this.notasCliente = [];
        this.limparNavegacaoVendas();
        await this.buscarVendasClienteSelecionado();
    }

    async buscarFiltroImpressao(): Promise<void> {
        this.limparNavegacaoVendas();

        if (this.clienteSelecionadoBusca) {
            await this.buscarVendasClienteSelecionado();
            return;
        }

        await this.buscarClientes();
    }

    async buscarVendasClienteSelecionado(): Promise<void> {
        const cliente = this.clienteSelecionadoBusca;

        if (!cliente) {
            this.buscaMensagem = 'Selecione um cliente para buscar as vendas.';
            return;
        }

        this.buscaMensagem = 'Carregando ultimas vendas do cliente...';

        const codparc = this.valorBusca(cliente, 'codparc') || this.valorBusca(cliente, 'CODPARC');

        if (!codparc) {
            this.buscaMensagem = 'Codigo do cliente nao localizado.';
            return;
        }

        try {
            const response: any = await this.respostaGateway(
                this.sankhyaGateway.buscarVendasImpressao({
                    CODPARC: Number(codparc),
                    DTINICIAL: this.buscaDataInicial,
                    DTFINAL: this.buscaDataFinal
                })
            );

            const lista = response?.vendas || response?.lista || [];
            this.notasCliente = this.filtrarNotasPorPeriodo(Array.isArray(lista) ? lista : []);
            this.buscaMensagem = this.notasCliente.length
                ? ''
                : 'Nenhuma venda encontrada para este cliente no período selecionado.';
        } catch (e) {
            console.error('Erro ao buscar notas do cliente:', e);
            this.notasCliente = [];
            this.buscaMensagem = 'Erro ao buscar notas do cliente.';
        }
    }

    async selecionarNotaBusca(
        nota: any,
        registrarNavegacao = true
    ): Promise<void> {
        const nunota = this.valorBusca(nota, 'NUNOTA') || this.valorBusca(nota, 'nunota');

        if (!nunota) {
            this.buscaMensagem = 'Numero unico nao localizado na nota selecionada.';
            return;
        }

        if (registrarNavegacao) {
            this.registrarNavegacaoVendas(nota);
        }

        const storage = this.getSessionStorage();
        storage?.removeItem(this.navegacaoVendaImpressaoKey);
        storage?.setItem('param_venda_impressao_nunota', String(nunota));
        storage?.setItem('param_venda_impressao_retorno', 'busca-venda-impressao');
        storage?.removeItem(this.estadoRetornoDemonstrativoKey);
        this.origemVoltarImpressao = 'busca';

        this.aguardandoSelecaoVenda = false;
        this.clientesBusca = [];
        this.buscaMensagem = '';
        await this.render();
    }

    get possuiNavegacaoVendas(): boolean {
        return !this.aguardandoSelecaoVenda &&
            this.notasNavegacao.length > 0 &&
            this.indiceNotaNavegacao >= 0;
    }

    get podeNavegarAnterior(): boolean {
        return this.possuiNavegacaoVendas &&
            this.indiceNotaNavegacao > 0 &&
            !this.carregando();
    }

    get podeNavegarProxima(): boolean {
        return this.possuiNavegacaoVendas &&
            this.indiceNotaNavegacao < this.notasNavegacao.length - 1 &&
            !this.carregando();
    }

    vendaAnterior(): void {
        if (!this.podeNavegarAnterior) {
            return;
        }

        void this.abrirNotaNavegacao(this.indiceNotaNavegacao - 1);
    }

    proximaVenda(): void {
        if (!this.podeNavegarProxima) {
            return;
        }

        void this.abrirNotaNavegacao(this.indiceNotaNavegacao + 1);
    }

    private async abrirNotaNavegacao(indice: number): Promise<void> {
        const nota = this.notasNavegacao[indice];

        if (!nota || this.carregando()) {
            return;
        }

        this.indiceNotaNavegacao = indice;

        if (this.origemVoltarImpressao === 'demonstrativo') {
            const nunota = this.notaNunotaBusca(nota);

            if (!nunota || nunota === '-') {
                return;
            }

            const storage = this.getSessionStorage();
            storage?.setItem('param_venda_impressao_nunota', nunota);
            storage?.setItem('param_venda_impressao_retorno', 'demonstrativo-vendas');
            storage?.removeItem('param_venda_impressao_fila');
            storage?.removeItem('param_venda_impressao_auto_print');

            this.aguardandoSelecaoVenda = false;
            await this.render();
            return;
        }

        await this.selecionarNotaBusca(nota, false);
    }

    private registrarNavegacaoVendas(notaSelecionada: any): void {
        this.notasNavegacao = [...this.notasCliente];

        const nunotaSelecionada = this.chaveNunota(notaSelecionada);
        this.indiceNotaNavegacao = this.notasNavegacao.findIndex(
            nota => this.chaveNunota(nota) === nunotaSelecionada
        );
    }

    private limparNavegacaoVendas(): void {
        this.notasNavegacao = [];
        this.indiceNotaNavegacao = -1;
    }

    private restaurarNavegacaoDemonstrativo(): void {
        const storage = this.getSessionStorage();
        const navegacaoSalva = storage?.getItem(this.navegacaoVendaImpressaoKey);

        if (!navegacaoSalva) {
            return;
        }

        try {
            const valor = JSON.parse(navegacaoSalva);

            if (!Array.isArray(valor)) {
                storage?.removeItem(this.navegacaoVendaImpressaoKey);
                return;
            }

            this.notasNavegacao = valor
                .map((nota) => typeof nota === 'string' ? {NUNOTA: nota} : nota)
                .filter((nota) => {
                    const nunota = this.notaNunotaBusca(nota);
                    return !!nunota && nunota !== '-';
                });

            const nunotaAtual = String(
                storage?.getItem('param_venda_impressao_nunota') ||
                new URLSearchParams(location.search).get('NUNOTA') ||
                new URLSearchParams(location.search).get('nunota') ||
                ''
            );

            this.indiceNotaNavegacao = this.notasNavegacao.findIndex(
                nota => this.chaveNunota(nota) === this.chaveNunota(nunotaAtual)
            );

            if (this.indiceNotaNavegacao >= 0) {
                this.origemVoltarImpressao = 'demonstrativo';
            }
        } catch (e) {
            console.warn('Navegacao do demonstrativo invalida:', e);
            storage?.removeItem(this.navegacaoVendaImpressaoKey);
            this.limparNavegacaoVendas();
        }
    }

    private chaveNunota(nota: any): string {
        const valor = typeof nota === 'object' && nota !== null
            ? this.notaNunotaBusca(nota)
            : String(nota || '');

        const normalizado = String(valor || '').trim();

        if (/^\d+$/.test(normalizado)) {
            return normalizado.replace(/^0+(?=\d)/, '');
        }

        return normalizado.toUpperCase();
    }

    labelClienteBusca(cliente: any): string {
        const nome = this.valorBusca(cliente, 'nomeparc') ||
            this.valorBusca(cliente, 'NOMEPARC') ||
            this.valorBusca(cliente, 'nomeParc') ||
            'Cliente nao informado';
        const doc = this.valorBusca(cliente, 'docparc') ||
            this.valorBusca(cliente, 'DOCPARC') ||
            this.valorBusca(cliente, 'CNPJ') ||
            this.valorBusca(cliente, 'CGC_CPF');

        return `${nome} - CNPJ: ${this.formatarDocumento(doc)}`;
    }

    labelNotaBusca(nota: any): string {
        const numeroNota = this.notaVendaBusca(nota);
        const data = this.notaDataBusca(nota);
        const status = this.notaStatusBusca(nota);
        const total = this.notaValorBusca(nota);

        return `No. unico ${this.valorBusca(nota, 'NUNOTA')} - Venda ${numeroNota} - ${data} - ${status} - R$ ${total}`;
    }

    notaNunotaBusca(nota: any): string {
        return this.valorBusca(nota, 'NUNOTA') || this.valorBusca(nota, 'nunota') || '-';
    }

    notaVendaBusca(nota: any): string {
        const numero = this.valorBusca(nota, 'NUMNOTA').replace(/\D/g, '');
        const data = this.valorBusca(nota, 'DTNEG');
        const ano = data.match(/\d{2}\/\d{2}\/(\d{4})/)?.[1]?.slice(-2) || '';

        if (!numero) {
            return '-';
        }

        return ano ? `${numero.padStart(7, '0')}/${ano}` : numero.padStart(7, '0');
    }

    notaDataBusca(nota: any): string {
        return this.valorBusca(nota, 'DTNEG') || '-';
    }

    notaStatusBusca(nota: any): string {
        return this.valorBusca(nota, 'STATUSNOTA') || '-';
    }

    notaValorBusca(nota: any): string {
        return this.money(this.valorBusca(nota, 'VLRNOTA'));
    }

    notaValorDolarBusca(nota: any): string {
        const valorReal = this.numeroBusca(nota, 'VLRNOTA');
        const cotacao = this.numeroBusca(nota, 'VLRMOEDA');

        if (!valorReal || !cotacao) {
            return this.money(0);
        }

        return this.money(valorReal / cotacao);
    }

    notaPrefixoBusca(nota: any): string {
        return this.valorBusca(nota, 'PREFIXO') || this.valorBusca(nota, 'prefixo');
    }

    notaCertificadoBusca(nota: any): string {
        return this.valorBusca(nota, 'CERTIFICADO') ||
            this.valorBusca(nota, 'AD_COM') ||
            this.valorBusca(nota, 'adCom') ||
            this.valorBusca(nota, 'COM');
    }

    private filtrarNotasPorPeriodo(notas: any[]): any[] {
        const inicial = this.dataInputParaDate(this.buscaDataInicial);
        const final = this.dataInputParaDate(this.buscaDataFinal);

        if (!inicial && !final) {
            return notas;
        }

        return notas.filter((nota) => {
            const dataNota = this.dataBrParaDate(this.valorBusca(nota, 'DTNEG'));

            if (!dataNota) {
                return true;
            }

            if (inicial && dataNota < inicial) {
                return false;
            }

            return !(final && dataNota > final);
        });
    }


    private possuiItensZeradosImpressao(): boolean {
        return this.documentos.some(documento =>
            (documento.items || []).some((item: any) => {
                const valorOriginal = item?.VLRUNIT;

                if (
                    valorOriginal === null ||
                    valorOriginal === undefined ||
                    String(valorOriginal).trim() === ''
                ) {
                    return false;
                }

                const valor = this.numeroMonetario(valorOriginal);

                return valor === 0 || valor === 0.01;
            })
        );
    }

    imprimir(): void {
        if (this.solicitarConfirmacaoItensZerados('imprimir')) {
            return;
        }

        void this.executarImpressao();
    }

    private solicitarConfirmacaoItensZerados(
        acao: 'imprimir' | 'pdf'
    ): boolean {
        if (!this.possuiItensZeradosImpressao()) {
            return false;
        }

        const modal = this.modalItensZerados?.nativeElement;

        if (!modal) {
            console.error('Modal de confirmação não encontrado.');
            return true;
        }

        this.acaoPendenteItensZerados = acao;

        if (!modal.open) {
            modal.showModal();
        }

        return true;
    }

    confirmarImpressaoItensZerados(): void {
        const acao = this.acaoPendenteItensZerados;

        this.acaoPendenteItensZerados = null;
        this.modalItensZerados?.nativeElement.close();

        if (acao === 'imprimir') {
            void this.executarImpressao();
        } else if (acao === 'pdf') {
            void this.executarGeracaoPdf();
        }
    }

    cancelarImpressaoItensZerados(): void {
        const modal = this.modalItensZerados?.nativeElement;

        if (modal?.open) {
            modal.close();
        }

        // Cancela também o estado de impressão automática.
        this.printEmAndamento = false;
        this.autoPrintAtivo = false;
        this.acaoPendenteItensZerados = null;

        this.getSessionStorage()
            ?.removeItem('param_venda_impressao_auto_print');
    }

    private async executarImpressao(): Promise<void> {
        this.aplicarModoImpressao();

        try {
            await this.prepararPaginas();
            window.print();
        } catch (erro) {
            alert(
                erro instanceof Error
                    ? erro.message
                    : 'Nao foi possivel paginar a impressao.'
            );
        }
    }

    voltarImpressao(): void {
        const storage = this.getSessionStorage();
        const veioDoDemonstrativo =
            this.origemVoltarImpressao === 'demonstrativo' ||
            (
                this.origemVoltarImpressao !== 'busca' &&
                (
                    !!storage?.getItem(this.estadoRetornoDemonstrativoKey) ||
                    storage?.getItem('param_venda_impressao_retorno') === 'demonstrativo-vendas'
                )
            );

        this.printEmAndamento = false;
        this.autoPrintAtivo = false;
        this.limparParametrosImpressao(storage);

        if (veioDoDemonstrativo) {
            this.activeViewChange.emit('demonstrativo-vendas');
            return;
        }

        this.limparDocumentoAtual();
        this.aguardandoSelecaoVenda = true;
        this.parametros = false;
        this.dropdownClientesAberto = false;
        this.buscaMensagem = this.clienteSelecionadoBusca && this.notasCliente.length
            ? ''
            : 'Digite o CNPJ ou nome do cliente para localizar as ultimas vendas.';
    }

    gerarPdf(): void {
        if (this.solicitarConfirmacaoItensZerados('pdf')) {
            return;
        }

        void this.executarGeracaoPdf();
    }

    private async executarGeracaoPdf(): Promise<void> {
        try { await this.prepararPaginas(); } catch (erro) {
            alert(erro instanceof Error ? erro.message : 'Nao foi possivel paginar o PDF.');
            return;
        }
        const paginasOriginais = Array.from(
            this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.paginated-pages .page')
        );

        if (!paginasOriginais.length) {
            alert('Área de impressão não encontrada.');
            return;
        }

        const paginasPb = paginasOriginais.filter(pagina => pagina.classList.contains('impressao-pb-page'));
        const estilosOriginais = paginasOriginais.map(pagina => ({
            pagina,
            pageBreakAfter: pagina.style.pageBreakAfter,
            breakAfter: pagina.style.breakAfter
        }));

        try {
            if ((document as any).fonts?.ready) {
                await (document as any).fonts.ready;
            }

            paginasPb.forEach(pagina => pagina.classList.remove('impressao-pb-page'));
            paginasOriginais.forEach(pagina => pagina.classList.add('pdf-capturing'));
            paginasOriginais.forEach((pagina, index) => {
                pagina.style.pageBreakAfter = index < paginasOriginais.length - 1 ? 'always' : 'auto';
                pagina.style.breakAfter = index < paginasOriginais.length - 1 ? 'page' : 'auto';
            });

            const imagens = Array.from(
                document.querySelectorAll<HTMLImageElement>('app-gpl-venda-impressao .page img')
            );

            await Promise.all(
                imagens.map((img) => {
                    if (img.complete) {
                        return Promise.resolve();
                    }

                    return new Promise<void>((resolve) => {
                        img.onload = () => resolve();
                        img.onerror = () => resolve();
                    });
                })
            );

            await new Promise(resolve => setTimeout(resolve, 300));

            const pdf = new jsPDF({
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait',
                compress: true
            });

            for (let index = 0; index < paginasOriginais.length; index++) {
                const pagina = paginasOriginais[index];
                const canvas = await html2canvas(pagina, {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    logging: false,
                    backgroundColor: '#ffffff',
                    scrollX: 0,
                    scrollY: -window.scrollY,
                    windowWidth: document.documentElement.scrollWidth,
                    windowHeight: document.documentElement.scrollHeight,
                    onclone: (documentClone: Document) => this.aplicarEstilosPdfNoClone(documentClone)
                });

                if (index > 0) {
                    pdf.addPage('a4', 'portrait');
                }

                pdf.addImage(
                    canvas.toDataURL('image/png'),
                    'PNG',
                    0,
                    0,
                    210,
                    297,
                    undefined,
                    'FAST'
                );
            }

            pdf.save(this.nomeArquivoPdf());

        } catch (e) {
            console.error('Erro ao gerar PDF:', e);
            alert('Erro ao gerar PDF');
        } finally {
            paginasOriginais.forEach(pagina => pagina.classList.remove('pdf-capturing'));
            estilosOriginais.forEach(({pagina, pageBreakAfter, breakAfter}) => {
                pagina.style.pageBreakAfter = pageBreakAfter;
                pagina.style.breakAfter = breakAfter;
            });
            paginasPb.forEach(pagina => pagina.classList.add('impressao-pb-page'));
        }
    }

    private aplicarEstilosPdfNoClone(documentClone: Document): void {
        documentClone.querySelectorAll<HTMLElement>('.paginated-pages').forEach(elemento =>
            elemento.style.setProperty('zoom', '1', 'important'));
        const raiz = documentClone.querySelector<HTMLElement>(
            'app-gpl-venda-impressao .paginated-pages'
        ) || documentClone.querySelector<HTMLElement>('.pdf-capturing');

        if (!raiz) {
            return;
        }

        const aplicar = (elemento: Element, estilos: Record<string, string>): void => {
            const style = (elemento as HTMLElement).style;

            Object.entries(estilos).forEach(([propriedade, valor]) => {
                style.setProperty(propriedade, valor, 'important');
            });
        };

        const aplicarTodos = (seletor: string, estilos: Record<string, string>): void => {
            raiz.querySelectorAll(seletor).forEach(elemento => aplicar(elemento, estilos));
        };

        const paginas = raiz.classList.contains('page')
            ? [raiz]
            : Array.from(raiz.querySelectorAll<HTMLElement>('.page'));

        paginas.forEach(pagina => aplicar(pagina, {
            'background': '#ffffff',
            'background-color': '#ffffff',
            'border': '1px solid rgba(148, 163, 184, .35)',
            'box-shadow': 'none',
            '-webkit-print-color-adjust': 'exact',
            'print-color-adjust': 'exact',
            'color-adjust': 'exact'
        }));

        aplicarTodos('.system-box', {
            'background': '#f3f6fa',
            'background-color': '#f3f6fa',
            'border': '1px solid #d9e2ef',
            'border-radius': '8px'
        });

        aplicarTodos('.doc-title', {
            'background': '#f8fbff',
            'background-color': '#f8fbff',
            'border': '1px solid #d9e2ef',
            'border-radius': '8px'
        });

        aplicarTodos(
            '.section-block, .meta-panel, .right-meta, .items-table, .total-box, .core-note, .pix-box',
            {
                'background': '#ffffff',
                'background-color': '#ffffff',
                'border': '1px solid #d9e2ef',
                'border-radius': '8px',
                'overflow': 'hidden'
            }
        );

        aplicarTodos('.section-title, .items-title-row th, .invoice-total', {
            'background': '#eef4ff',
            'background-color': '#eef4ff',
            'color': '#174ea6',
            'border-bottom': '1px solid #d9e2ef'
        });

        aplicarTodos('thead th', {
            'background': '#f6f8fb',
            'background-color': '#f6f8fb',
            'color': '#344054',
            'border-bottom': '1px solid #d9e2ef'
        });

        aplicarTodos('.validity', {
            'background': '#fff9eb',
            'background-color': '#fff9eb',
            'border': '1px solid #f0c36d',
            'border-left': '4px solid #d99000',
            'border-radius': '8px',
            'color': '#7a4b00'
        });

        aplicarTodos(
            '.items-table tbody tr.item-row td, .items-table tbody tr.serial-row td',
            {
                'background': '#ffffff',
                'background-color': '#ffffff',
                'border-bottom': '1px solid #eef1f5'
            }
        );

        aplicarTodos('.items-table tbody tr.item-row-alt td', {
            'background': '#f5f9ff',
            'background-color': '#f5f9ff'
        });

        aplicarTodos('.items-table tbody tr.item-valor-zerado td', {
            'background': '#fde2e2',
            'background-color': '#fde2e2'
        });

        aplicarTodos('.total-row > div, .invoice-total > div', {
            'border-bottom': '1px solid #eef1f5'
        });

        aplicarTodos('.pix-box', {
            'background': '#fffafa',
            'background-color': '#fffafa',
            'border': '1px solid #f0b6b6'
        });

        aplicarTodos('.pix-qrcode', {
            'background': '#ffffff',
            'background-color': '#ffffff',
            'border': '1px solid #f0d4d4'
        });
    }

    alternarParametro(param: string, checked: boolean): void {
        this.params[param] = checked;
    }

    visivel(param: string): boolean {
        return !!this.params[param];
    }

    acaoVoltarOuFechar(): void {
        if (this.modoModal) {
            this.fecharModal.emit();
            return;
        }

        this.voltarImpressao();
    }

    @HostListener('scroll')
    @HostListener('window:resize')
    atualizarNavegacaoRolagem(): void {
        if (!this.modoModal) {
            this.mostrarIrTopo = false;
            this.mostrarIrFinal = false;
            return;
        }

        const container = this.elementRef.nativeElement;
        const limite = 24;
        this.mostrarIrTopo = container.scrollTop > limite;
        this.mostrarIrFinal = container.scrollTop + container.clientHeight < container.scrollHeight - limite;
    }

    irParaTopoImpressao(): void {
        this.elementRef.nativeElement.scrollTo({top: 0, behavior: 'smooth'});
    }

    irParaFinalImpressao(): void {
        const container = this.elementRef.nativeElement;
        container.scrollTo({top: container.scrollHeight, behavior: 'smooth'});
    }

    exibirColunaDescricao(): boolean {
        return this.visivel('IMP_DESC') || this.visivel('IMP_FABR') || this.visivel('IMP_CD');
    }

    visivelTodos(params: string): boolean {
        return params
            .split(',')
            .map(p => p.trim())
            .every(p => this.params[p]);
    }

    valoresEmDolar(): boolean {
        return this.params?.IMP_MOEDA === 'USD';
    }

    itemsTableColspan(documento: { possuiCoreAtual?: boolean; items?: any[] } = {}): number {
        const possuiCoreAtual = !!documento.possuiCoreAtual;

        let total = 2; // Ord + Qtd.

        if (this.visivel('IMP_PN')) total++;
        if (this.exibirColunaDescricao()) total++;

        if (this.exibirIpiDocumento(documento)) total++;
        if (this.exibirStrDocumento(documento)) total++;

        if (
            this.visivel('IMP_VLR') &&
            (this.visivel('IMP_DOL') || this.valoresEmDolar())
        ) total++;
        if (this.visivel('IMP_VLR') && !this.valoresEmDolar()) total++;
        if (possuiCoreAtual) total++;
        if (possuiCoreAtual && this.visivel('IMP_VLR')) total++;
        if (this.visivel('IMP_VLR')) total++;

        return total;
    }

    itemPossuiCore(item: any): boolean {
        const core = this.value(item, 'CORE').trim().toUpperCase();

        return core !== '' && core !== 'N';
    }

    itemPossuiSerial(item: any): boolean {
        return this.value(item, 'AD_SERIAL').trim() !== '';
    }

    seriaisItem(item: any): string[] {
        const serial = this.value(item, 'AD_SERIAL');

        if (!serial.trim()) {
            return [];
        }

        return serial
            .split(',')
            .map(s => s.trim())
            .filter(s => s !== '');
    }

    totalCampoDocumento(items: any[] = [], campo: string): string {
        return this.money(
            items.reduce(
                (total: number, item: any) =>
                    total + this.numeroMonetario(item?.[campo]),
                0
            )
        );
    }

    documentoPossuiIpi(documento: { items?: any[] } = {}): boolean {
        return (documento.items || []).some(
            (item: any) => this.itemPossuiIpi(item)
        );
    }

    documentoPossuiStr(documento: { items?: any[] } = {}): boolean {
        return (documento.items || []).some(
            (item: any) => this.itemPossuiStr(item)
        );
    }

    exibirIpiDocumento(documento: { items?: any[] } = {}): boolean {
        return !this.valoresEmDolar() &&
            this.visivel('IMP_IPI') &&
            this.documentoPossuiIpi(documento);
    }

    exibirStrDocumento(documento: { items?: any[] } = {}): boolean {
        return !this.valoresEmDolar() &&
            this.visivel('IMP_ST') &&
            this.documentoPossuiStr(documento);
    }

    itemPossuiIpi(item: any): boolean {
        return this.numeroMonetario(item?.VLRIPI) !== 0;
    }

    itemPossuiStr(item: any): boolean {
        return this.numeroMonetario(item?.VLRSUBST) !== 0;
    }

    numeroMonetario(valor: any): number {
        if (valor === null || valor === undefined || valor === '') {
            return 0;
        }

        let texto = String(valor).trim();

        if (!texto || texto === '0' || texto === '0,00' || texto === '0.00') {
            return 0;
        }

        const ultimoPonto = texto.lastIndexOf('.');
        const ultimaVirgula = texto.lastIndexOf(',');

        if (ultimoPonto !== -1 && ultimaVirgula !== -1) {
            if (ultimaVirgula > ultimoPonto) {
                texto = texto.replace(/\./g, '').replace(',', '.');
            } else {
                texto = texto.replace(/,/g, '');
            }
        } else if (ultimaVirgula !== -1) {
            texto = texto.replace(',', '.');
        }

        const numero = Number(texto);

        return Number.isFinite(numero) ? numero : 0;
    }

    totalComCore(item: any, data: any): number {
        const valorUnitario = this.numeroMonetario(item?.VLRUNIT);
        const quantidade = this.numeroMonetario(item?.QTDNEG);

        const totalPeca = valorUnitario * quantidade;
        const valorIpi = this.numeroMonetario(item?.VLRIPI);
        const valorStr = this.numeroMonetario(item?.VLRSUBST);
        const valorCore = this.valorCoreItem(item, data);

        return totalPeca + valorIpi + valorStr + valorCore;
    }

    private arredondarValor(valor: number): number {
        return Math.round((valor + Number.EPSILON) * 100) / 100;
    }

    private totalBrutoPeca(item: any): number {
        return item?.VLRTOT != null && item.VLRTOT !== ''
            ? this.numeroMonetario(item.VLRTOT)
            : this.numeroMonetario(item?.VLRUNIT) * this.numeroMonetario(item?.QTDNEG);
    }

    private descontoRegistradoItem(item: any): number {
        return item?.VLRDESC != null && item.VLRDESC !== ''
            ? this.numeroMonetario(item.VLRDESC)
            : this.arredondarValor(this.totalBrutoPeca(item) * this.numeroMonetario(item?.PERCDESC) / 100);
    }

    private descontoItem(item: any, data: any = {}): number {
        const items: any[] = data.items || [];
        // O desconto distribuido nos itens nao deve ser descontado novamente pelo cabecalho.
        if (!items.length || items.some(atual => this.descontoRegistradoItem(atual) !== 0)) {
            return this.descontoRegistradoItem(item);
        }
        const total = items.reduce((soma, atual) => soma + this.totalBrutoPeca(atual), 0);
        const indice = items.indexOf(item);
        if (!total || indice < 0) return 0;
        const anterior = items.slice(0, indice).reduce((soma, atual) => soma + this.totalBrutoPeca(atual), 0);
        const desconto = this.numeroMonetario(data.VLRDESCTOT);
        // Rateio acumulado conserva os centavos do desconto total.
        return this.arredondarValor(desconto * (anterior + this.totalBrutoPeca(item)) / total)
            - this.arredondarValor(desconto * anterior / total);
    }

    private descontoItemExibicao(item: any, data: any): number {
        return this.valoresEmDolar() ? this.descontoItemDolar(item, data) : this.descontoItem(item, data);
    }

    private descontoItemDolar(item: any, data: any): number {
        const desconto = this.descontoItem(item, data);
        const bruto = this.totalBrutoPeca(item);
        return bruto ? this.arredondarValor(
            this.numeroMonetario(item?.VLRUNITMOEDA) * this.numeroMonetario(item?.QTDNEG) * desconto / bruto
        ) : 0;
    }

    valorUnitarioVisual(item: any, data: any = {}): number {
        const quantidade = this.numeroMonetario(item?.QTDNEG);
        const valorUnitario = quantidade
            ? (this.totalBrutoPeca(item) - (this.visivel('IMP_DES') ? 0 : this.descontoItem(item, data))) / quantidade
            : this.numeroMonetario(item?.VLRUNIT);

        if (!quantidade) {
            return valorUnitario;
        }

        const ipiEmbutido = this.visivel('IMP_IPI')
            ? 0
            : this.numeroMonetario(item?.VLRIPI);
        const stEmbutido = this.visivel('IMP_ST')
            ? 0
            : this.numeroMonetario(item?.VLRSUBST);

        return valorUnitario + ((ipiEmbutido + stEmbutido) / quantidade);
    }

    valorUnitarioDolarVisual(item: any, data: any): number {
        const valorUnitarioDolar = this.numeroMonetario(
            item?.VLRUNITMOEDA
        );

        const quantidade = this.numeroMonetario(item?.QTDNEG);
        return valorUnitarioDolar - (!this.visivel('IMP_DES') && quantidade
            ? this.descontoItemDolar(item, data) / quantidade : 0);
    }

    valorUnitarioExibicao(item: any, data: any): number {
        return this.valoresEmDolar()
            ? this.valorUnitarioDolarVisual(item, data)
            : this.valorUnitarioVisual(item, data);
    }

    valorCoreExibicao(item: any, data: any): number {
        if (!this.valoresEmDolar()) {
            return this.valorCoreItem(item, data);
        }

        if (!this.itemPossuiCore(item)) {
            return 0;
        }

        const valorCoreAtual = this.numeroMonetario(item?.VLRCORE);
        const quantidade = this.numeroMonetario(item?.QTDNEG);

        return valorCoreAtual * quantidade;
    }

    totalItemExibicao(item: any, data: any): number {
        const valorUnitario = this.valorUnitarioExibicao(item, data);
        const quantidade = this.numeroMonetario(item?.QTDNEG);
        const valorCore = this.valorCoreExibicao(item, data);

        let totalItem = valorUnitario * quantidade;

        const adCore = this.value(item, 'AD_CORE')
            .trim()
            .toUpperCase();

        if (adCore === 'S') {
            totalItem += valorCore;
        }

        if (this.valoresEmDolar()) {
            return this.arredondarValor(totalItem);
        }

        if (this.visivel('IMP_IPI')) {
            totalItem += this.numeroMonetario(item?.VLRIPI);
        }

        if (this.visivel('IMP_ST')) {
            totalItem += this.numeroMonetario(item?.VLRSUBST);
        }

        return this.arredondarValor(totalItem);
    }

    moneyVisual(valor: any): string {
        const numero = this.numeroMonetario(valor);

        return numero === 0
            ? '---'
            : this.money(numero);
    }

    moedaTitulo(label: string): string {
        return `${label} ${this.valoresEmDolar() ? 'U$' : 'R$'}`;
    }

    private valorMoedaMinimaDolar(valor: any, cotacao: number): number {
        const numero = this.numeroMonetario(valor);

        if (numero <= 0 || cotacao <= 0) {
            return 0;
        }

        const convertido = numero / cotacao;

        return convertido > 0 && convertido < 0.01
            ? 0.01
            : convertido;
    }

    private cotacaoDolar(data: any = {}, item: any = {}): number {
        const cotacaoCabecalho = [
            data?.VLRMOEDA,
            data?.DOLAR,
            data?.COTACAO,
            data?.COTACAO_DOLAR,
            data?.VLRCOTACAO
        ]
            .map(valor => this.numeroMonetario(valor))
            .find(valor => valor > 0);

        if (cotacaoCabecalho) {
            return cotacaoCabecalho;
        }

        const valorReal = this.numeroMonetario(item?.VLRUNIT);
        const valorDolar = this.numeroMonetario(item?.VLRUNITMOEDA);

        if (valorReal > 0 && valorDolar > 0) {
            return valorReal / valorDolar;
        }

        const itemBase = this.items.find((itemAtual: any) =>
            this.numeroMonetario(itemAtual?.VLRUNIT) > 0 &&
            this.numeroMonetario(itemAtual?.VLRUNITMOEDA) > 0
        );

        if (itemBase) {
            return this.numeroMonetario(itemBase.VLRUNIT) /
                this.numeroMonetario(itemBase.VLRUNITMOEDA);
        }

        return 0;
    }

    valorCoreItem(item: any, data: any): number {
        if (!this.itemPossuiCore(item)) {
            return 0;
        }

        const valorCoreAtual = this.numeroMonetario(item?.VLRCORE);
        const cotacao = this.cotacaoDolar(data, item);
        const quantidade = this.numeroMonetario(item?.QTDNEG);

        return valorCoreAtual * cotacao * quantidade;
    }

    totalCampo(campo: string): string {
        return this.money(
            this.items.reduce(
                (total: number, item: any) =>
                    total + this.numeroMonetario(item?.[campo]),
                0
            )
        );
    }

    totalCore(): string {
        const total = this.items.reduce(
            (acumulado: number, item: any) =>
                acumulado + this.valorCoreItem(item, this.data),
            0
        );

        return this.money(total);
    }

    totalGeral(items: any[] = this.items): string {
        const totalItens = items.reduce(
            (acumulado: number, item: any) =>
                acumulado + this.totalComCore(item, this.data),
            0
        );

        const frete = this.numeroMonetario(this.data?.VLRFRETE);

        return this.money(totalItens + frete);
    }

    value(data: any, key: string): string {
        return data?.[key] == null ? '' : String(data[key]);
    }

    mesmoClienteFaturadoEntrega(data: any): boolean {
        const codFaturado = this.normalizarComparacao(
            this.value(data, 'CODPARC')
        );

        const codEntrega = this.normalizarComparacao(
            this.valorPrimeiro(data, [
                'CODPARCENTREGA',
                'CODPARC_ENTREGA',
                'CODPARCDEST',
                'CODPARCDESTINO',
                'AD_CODPARCENTREGA'
            ])
        );

        const enderecoFaturado = this.normalizarComparacao([
            this.value(data, 'NOMEEND'),
            this.value(data, 'NOMEBAI'),
            this.value(data, 'NOMECID'),
            this.value(data, 'UF'),
            this.value(data, 'CEP')
        ].join(' '));

        const enderecoEntregaEspecifico = this.normalizarComparacao([
            this.valorPrimeiro(data, ['NOMEENDENTREGA', 'ENDENTREGA_AD', 'ENDENTREGA']),
            this.valorPrimeiro(data, ['BAIRROENTREGA', 'NOMEBAIENTREGA']),
            this.valorPrimeiro(data, ['CIDADEENTREGA', 'NOMECIDENTREGA']),
            this.valorPrimeiro(data, ['UFENTREGA']),
            this.valorPrimeiro(data, ['CEPENTREGA'])
        ].join(' '));

        if (enderecoFaturado && enderecoEntregaEspecifico) {
            return enderecoFaturado === enderecoEntregaEspecifico;
        }

        if (codFaturado && codEntrega) {
            return codFaturado === codEntrega;
        }

        if (!enderecoEntregaEspecifico) {
            return !codEntrega;
        }

        const enderecoEntrega = this.normalizarComparacao([
            this.valorPrimeiro(data, ['NOMEENDENTREGA', 'ENDENTREGA_AD', 'ENDENTREGA']),
            this.valorPrimeiro(data, ['BAIRROENTREGA', 'NOMEBAIENTREGA']),
            this.valorPrimeiro(data, ['CIDADEENTREGA', 'NOMECIDENTREGA']),
            this.valorPrimeiro(data, ['UFENTREGA']),
            this.valorPrimeiro(data, ['CEPENTREGA'])
        ].join(' '));

        return !!enderecoFaturado &&
            !!enderecoEntrega &&
            enderecoFaturado === enderecoEntrega;
    }

    tituloEntrega(data: any): string {
        return this.mesmoClienteFaturadoEntrega(data)
            ? 'CLIENTE A SER FATURADO / ENTREGA'
            : 'Entrega';
    }

    entregaCliente(data: any): string {
        return this.valorEntrega(data, ['PARCEIROENTREGA', 'NOMEPARC']);
    }

    entregaDocumento(data: any): string {
        return this.valorEntrega(data, ['CNPJENTREGA', 'CNPJ']);
    }

    entregaIe(data: any): string {
        return this.valorEntrega(data, ['IEENTREGA', 'INSCMUN']);
    }

    entregaEndereco(data: any): string {
        const enderecoEntrega = this.valorEntrega(data, [
            'ENDENTREGA',
            'NOMEEND'
        ]);

        return this.limparEnderecoEntrega(enderecoEntrega);
    }

    entregaBairro(data: any): string {
        return this.valorEntrega(data, ['BAIRROENTREGA', 'NOMEBAI']);
    }

    entregaCidadeUf(data: any): string {
        const cidade = this.valorEntrega(data, ['CIDADEENTREGA', 'NOMECID']);
        const uf = this.valorEntrega(data, ['UFENTREGA', 'UF']);

        return [cidade, uf].filter(Boolean).join('-');
    }

    entregaCep(data: any): string {
        return this.maskCEP(
            this.valorEntrega(data, ['CEPENTREGA', 'CEP'])
        );
    }

    entregaFone(data: any): string {
        return this.maskTelefone(
            this.valorEntrega(data, ['TELENTREGA', 'TELPARC'])
        );
    }

    entregaEmail(data: any): string {
        return this.valorEntrega(data, ['EMAILENTREGA', 'EMAILPARC']);
    }

    entregaTransportador(data: any): string {
        const transportador = this.valorEntrega(data, ['TRANSPORTADOR']);

        return transportador.trim().toUpperCase() === '<SEM PARCEIRO>'
            ? ''
            : transportador;
    }

    entregaEnvio(data: any): string {
        return this.valorEntrega(data, ['ENVIO', 'FORMAENVIO']);
    }

    entregaVolumes(data: any): string {
        return this.valorEntrega(data, ['VOLUME', 'VOLUMES']);
    }

    mostrarDadosEntregaTransporte(data: any): boolean {
        return !!(
            this.entregaTransportador(data) ||
            this.entregaEnvio(data) ||
            this.entregaVolumes(data)
        );
    }

    dataHoraCabecalho(data: any): string {
        const dataTexto = this.value(data, 'DTATUAL');
        const horaTexto = this.value(data, 'HRATUAL');
        const dataCurta = dataTexto.replace(
            /(\d{2})\/(\d{2})\/(\d{2})\d{2}/,
            '$1/$2/$3'
        );
        const horaCurta = horaTexto.slice(0, 5);

        return [dataCurta, horaCurta].filter(Boolean).join(' ');
    }

    totalCoreDocumento(items: any[] = [], data: any = {}): number {
        return items.reduce(
            (total: number, item: any) =>
                total + this.valorCoreExibicao(item, data),
            0
        );
    }

    firstTwoNames(name: string): string {
        return String(name || '')
            .trim()
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 2)
            .join(' ');
    }

    money(number: any): string {
        return Number(number || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    nunotaFormatado(data = this.data): string {
        const nunota = this.value(data, 'NUNOTA').replace(/\D/g, '');
        return nunota ? nunota.padStart(7, '0') : '';
    }

    codigoBarrasNunota(data: any): CodigoBarrasNunota | null {
        const nunota = this.value(data, 'NUNOTA').trim();
        if (!this.codigosBarras.has(nunota)) {
            this.codigosBarras.set(nunota, gerarCodigoBarrasNunota(nunota));
        }
        return this.codigosBarras.get(nunota) ?? null;
    }

    emailLabel(): string {
        return this.data?.EMAILPARC
            ? 'email'
            : 'email não informado';
    }

    prefixoHtml(): string {
        return this.data?.PREFIXO
            ? `Prefixo: ${this.value(this.data, 'PREFIXO')}`
            : '';
    }

    private valorBusca(objeto: any, key: string): string {
        const value = objeto?.[key];

        return value === null || value === undefined
            ? ''
            : String(value);
    }

    private valorEntrega(data: any, keys: string[]): string {
        for (const key of keys) {
            const value = this.value(data, key).trim();

            if (value) {
                return value;
            }
        }

        return '';
    }

    private valorPrimeiro(data: any, keys: string[]): string {
        for (const key of keys) {
            const value = this.value(data, key).trim();

            if (value) {
                return value;
            }
        }

        return '';
    }

    private limparEnderecoEntrega(endereco: string): string {
        return String(endereco || '')
            .split(/\s+-\s+/)[0]
            .replace(/\s+CEP\s*:?\s*\d+.*/i, '')
            .trim();
    }

    private normalizarComparacao(valor: string): string {
        return String(valor || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^A-Z0-9]/gi, '')
            .toUpperCase();
    }

    private numeroBusca(objeto: any, key: string): number {
        const raw = this.valorBusca(objeto, key).trim();

        if (!raw) {
            return 0;
        }

        const normalizado = raw.includes(',')
            ? raw.replace(/\./g, '').replace(',', '.')
            : raw;

        const valor = Number(normalizado);

        return Number.isFinite(valor) ? valor : 0;
    }

    private removerClientesDuplicados(lista: unknown): any[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        const vistos = new Set<string>();
        const clientes: any[] = [];

        for (const cliente of lista) {
            const doc = this.valorBusca(cliente, 'docparc') ||
                this.valorBusca(cliente, 'DOCPARC') ||
                this.valorBusca(cliente, 'CNPJ') ||
                this.valorBusca(cliente, 'CGC_CPF');

            const codparc = this.valorBusca(cliente, 'codparc') ||
                this.valorBusca(cliente, 'CODPARC');

            const documento = doc.replace(/\D/g, '');
            const chave = documento || `CODPARC:${codparc}`;

            if (!chave || vistos.has(chave)) {
                continue;
            }

            vistos.add(chave);
            clientes.push(cliente);
        }

        return clientes;
    }

    private formatarDocumento(doc: string): string {
        const digitos = String(doc || '').replace(/\D/g, '');

        if (digitos.length === 14) {
            return digitos.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                '$1.$2.$3/$4-$5'
            );
        }

        if (digitos.length === 11) {
            return digitos.replace(
                /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                '$1.$2.$3-$4'
            );
        }

        return doc || '';
    }

    private domingoDaSemana(data: Date): Date {
        const domingo = new Date(data);

        domingo.setDate(data.getDate() - data.getDay());

        return domingo;
    }

    private diasAntes(data: Date, dias: number): Date {
        const dataCalculada = new Date(data);

        dataCalculada.setDate(data.getDate() - dias);

        return dataCalculada;
    }

    private formatarDataInput(data: Date): string {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');

        return `${ano}-${mes}-${dia}`;
    }

    private dataInputParaDate(valor: string): Date | null {
        const partes = String(valor || '').split('-').map(Number);

        if (partes.length !== 3 || partes.some(Number.isNaN)) {
            return null;
        }

        return new Date(partes[0], partes[1] - 1, partes[2]);
    }

    private dataBrParaDate(valor: string): Date | null {
        const partes = String(valor || '').split('/').map(Number);

        if (partes.length !== 3 || partes.some(Number.isNaN)) {
            return null;
        }

        return new Date(partes[2], partes[1] - 1, partes[0]);
    }

    aplicarModoImpressao(): void {
        document.body.classList.toggle(
            'impressao-pb',
            this.impressaoPB
        );

        const paginas = document.querySelectorAll<HTMLElement>(
            'app-gpl-venda-impressao .page'
        );

        paginas.forEach((pagina) => {
            pagina.classList.toggle(
                'impressao-pb-page',
                this.impressaoPB
            );
        });
    }

    private nomeArquivoPdf(): string {
        const numero = this.value(this.data, 'NUNOTA') || 'orcamento';
        const cliente = this.value(this.data, 'NOMEPARC') || 'cliente';

        const nomeCliente = cliente
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '')
            .replace(/[^\w]/g, '')
            .toUpperCase();

        const dataHora = new Date()
            .toLocaleString('pt-BR')
            .replace(/\D/g, '')
            .substring(0, 12);

        return `ORCAMENTO_${numero}_${nomeCliente}_${dataHora}.pdf`;
    }

    private agendarPrintAutomatico(): void {
        if (!this.autoPrintAtivo || this.printEmAndamento) {
            return;
        }

        this.printEmAndamento = true;

        setTimeout(() => {
            this.imprimir();
        }, 700);
    }

    @HostListener('window:afterprint')
    finalizarPrintAutomatico(): void {
        if (!this.printEmAndamento) {
            return;
        }

        const storage = this.getSessionStorage();
        const retorno = storage?.getItem('param_venda_impressao_retorno');

        this.printEmAndamento = false;

        if (storage) {
            storage.removeItem('param_venda_impressao_auto_print');
            storage.removeItem('param_venda_impressao_fila');
            storage.removeItem('param_venda_impressao_nunota');
            storage.removeItem('param_venda_impressao_retorno');
        }

        if (retorno === 'demonstrativo-vendas') {
            this.activeViewChange.emit('demonstrativo-vendas');
        }
    }

    private getSessionStorage(): Storage | null {
        try {
            return window.top?.sessionStorage || window.sessionStorage;
        } catch (e) {
            console.warn('Não foi possível acessar a sessão:', e);
            return null;
        }
    }

    private lerFilaOrcamentos(storage: Storage | null): string[] {
        if (!storage) {
            return [];
        }

        try {
            const fila = JSON.parse(
                storage.getItem('param_venda_impressao_fila') || '[]'
            );

            return Array.isArray(fila) ? fila : [];
        } catch (e) {
            console.warn('Fila de orçamentos inválida:', e);
            return [];
        }
    }

    private salvarFilaOrcamentos(
        storage: Storage | null,
        fila: string[]
    ): void {
        if (!storage) {
            return;
        }

        if (fila.length > 0) {
            storage.setItem(
                'param_venda_impressao_fila',
                JSON.stringify(fila)
            );
        } else {
            storage.removeItem('param_venda_impressao_fila');
        }
    }

    private consumirNunotaDaFila(storage: Storage | null): string | null {
        const fila = this.lerFilaOrcamentos(storage);
        const nunota = fila.shift() || null;

        this.salvarFilaOrcamentos(storage, fila);

        return nunota;
    }

    private consumirLoteAutomatico(): string[] {
        const storage = this.getSessionStorage();

        if (
            !storage ||
            storage.getItem('param_venda_impressao_auto_print') !== 'S'
        ) {
            return [];
        }

        const fila = this.lerFilaOrcamentos(storage);

        if (fila.length <= 1) {
            return [];
        }

        storage.removeItem('param_venda_impressao_fila');
        this.autoPrintAtivo = true;

        return fila;
    }

    private aplicarDocumentoAtual(documento: {
        data: any;
        items: any[];
        contas: any[];
        possuiCoreAtual: boolean;
        printDate: string;
    }): void {
        this.data = documento.data;
        this.items = documento.items;
        this.contas = documento.contas;
        this.possuiCoreAtual = documento.possuiCoreAtual;
        this.printDate = documento.printDate;
    }

    private limparDocumentoAtual(): void {
        this.data = {};
        this.items = [];
        this.contas = [];
        this.documentos = [];
        this.printDate = new Date().toLocaleString('pt-BR');
        this.possuiCoreAtual = false;
    }

    private limparParametrosImpressao(
        storage = this.getSessionStorage()
    ): void {
        storage?.removeItem('param_venda_impressao_auto_print');
        storage?.removeItem('param_venda_impressao_fila');
        storage?.removeItem('param_venda_impressao_nunota');
        storage?.removeItem('param_venda_impressao_retorno');
        storage?.removeItem(this.navegacaoVendaImpressaoKey);
    }

    private async respostaGateway<T = any>(observable: any): Promise<T> {
        const value: any = await firstValueFrom(observable);

        if (!value) {
            throw new Error('Resposta vazia do gateway.');
        }

        if (value.status && value.status !== '1') {
            throw new Error(
                value.statusMessage ||
                'Service não retornou sucesso.'
            );
        }

        return (value.responseBody || value) as T;
    }

    zoomVenda(tipo: '+' | '-'): void {
        if (tipo === '+' && this.vendaZoomAtual < 1.8) {
            this.vendaZoomAtual += 0.1;
        }

        if (tipo === '-' && this.vendaZoomAtual > 0.7) {
            this.vendaZoomAtual -= 0.1;
        }

        this.vendaZoomAtual = Number(
            this.vendaZoomAtual.toFixed(1)
        );
        setTimeout(() => this.atualizarNavegacaoRolagem());
    }

    alternarZoomVenda(): void {
        this.vendaZoomAtual = this.vendaZoomAtual >= 1.8
            ? 1.0
            : 1.8;
        setTimeout(() => this.atualizarNavegacaoRolagem());
    }

    pageA4Style(): Record<string, string> {
        return {
            transform: `scale(${this.vendaZoomAtual})`,
            transformOrigin: 'top center'
        };
    }

    valorDocumentoExibicao(valor: any, data: any): number {
        const numero = this.numeroMonetario(valor);

        if (!this.valoresEmDolar()) {
            return numero;
        }

        const cotacao = this.cotacaoDolar(data);

        if (!cotacao) {
            return numero;
        }

        return numero / cotacao;
    }

    totalPecasDocumento(items: any[] = [], data: any = {}): number {
        return items.reduce(
            (total: number, item: any) => {
                const valorUnitario = this.valorUnitarioExibicao(item, data);
                const quantidade = this.numeroMonetario(item?.QTDNEG);

                return this.arredondarValor(total + this.arredondarValor(valorUnitario * quantidade));
            },
            0
        );
    }

    totalIpiDocumento(items: any[] = []): number {
        return items.reduce(
            (total: number, item: any) =>
                total + this.numeroMonetario(item?.VLRIPI),
            0
        );
    }

    totalStrDocumento(items: any[] = []): number {
        return items.reduce(
            (total: number, item: any) =>
                total + this.numeroMonetario(item?.VLRSUBST),
            0
        );
    }

    sinalDescontoDocumento(data: any): '+' | '-' {
        return this.descontoDocumento(data) < 0 ? '+' : '-';
    }

    valorDescontoDocumentoExibicao(data: any): number {
        return Math.abs(this.descontoDocumento(data));
    }

    private descontoDocumento(data: any): number {
        const items: any[] = data?.items || [];
        return items.length
            ? this.arredondarValor(items.reduce((total, item) => total + this.descontoItemExibicao(item, data), 0))
            : this.valorDocumentoExibicao(data?.VLRDESCTOT, data);
    }

    private totalGeralCalculadoDocumento(documento: any): number {
        const items: any[] = Array.isArray(documento?.items)
            ? documento.items
            : [];

        const data = documento?.data || {};

        const totalItens = items.reduce(
            (total: number, item: any) =>
                total + this.totalItemExibicao(item, data),
            0
        );

        const frete = this.valorDocumentoExibicao(
            data.VLRFRETE,
            data
        );

        const desconto = this.visivel('IMP_DES') ? this.descontoDocumento({...data, items}) : 0;

        return this.arredondarValor(totalItens
            + frete
            - desconto);
    }

    totalGeralDocumento(documento: any): number {
        const data = documento?.data || {};

        if (data.VLRNOTA == null || data.VLRNOTA === '') {
            return this.totalGeralCalculadoDocumento(documento);
        }

        return this.valorDocumentoExibicao(data.VLRNOTA, data);
    }

    maskCEP(valor: any): string {
        if (!valor) {
            return '';
        }

        const cep = String(valor).replace(/\D/g, '');

        if (cep.length !== 8) {
            return String(valor);
        }

        return cep.replace(
            /^(\d{2})(\d{3})(\d{3})$/,
            '$1.$2-$3'
        );
    }

    maskTelefone(valor: any): string {
        if (!valor) {
            return '';
        }

        const telefone = String(valor).replace(/\D/g, '');

        // Celular: 62999998888 -> (62) 99999-8888
        if (telefone.length === 11) {
            return telefone.replace(
                /^(\d{2})(\d{5})(\d{4})$/,
                '($1) $2-$3'
            );
        }

        // Fixo: 6233334444 -> (62) 3333-4444
        if (telefone.length === 10) {
            return telefone.replace(
                /^(\d{2})(\d{4})(\d{4})$/,
                '($1) $2-$3'
            );
        }

        return String(valor);
    }

    usuarioLogado(): string {
        const tipo = localStorage.getItem('authStorageType');

        const name =
            tipo === 'session'
                ? sessionStorage.getItem('userName') || ''
                : localStorage.getItem('userName') ||
                sessionStorage.getItem('userName') ||
                '';

        if (!name) {
            return '-';
        }

        return name.split(' ')[0];
    }
}
